export const PendingChangesDrawerTestIds = {
  DRAWER: 'pending-changes-drawer.container',
  SAVE_BUTTON: 'pending-changes-drawer.save-button',
  CANCEL_BUTTON: 'pending-changes-drawer.cancel-button',
  CLOSE_BUTTON: 'pending-changes-drawer.close-button',
  EXPAND_ALL_BUTTON: 'pending-changes-drawer.expand-all-button',
  COLLAPSE_ALL_BUTTON: 'pending-changes-drawer.collapse-all-button',
};
